module.exports = __webpack_public_path__ + "media/2022/research-team-dbbde401.png";